import React from "react";
import axios from "axios";
import { TICKET_STATUS } from "helpers/helper";
import { cloneDeep } from "lodash";
import { Alert } from "@texada/ui";
import i18n from "i18n/i18n";
import * as types from "constants/ActionTypes";
import { TICKET_ASSIGN_URL, ALERT_ERROR_TIMEOUT } from "constants/AppConstants";
import { selectTicket } from ".";

axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFToken";

export const closeTickets = ({
  selectedTickets,
  ticketType,
  isEdit = false,
  showError = true,
  statusCodes = []
}) => (dispatch, getState) => {
  dispatch({
    type: types.POST_TICKET_DATA_REQUEST,
    value: {
      isLoading: true
    }
  });

  let tickets = cloneDeep(getState().tickets);
  const updateReqs = [];

  selectedTickets.forEach((ticket, i) => {
    const index = tickets.results.findIndex(e => e.id === ticket.id);

    updateReqs.push(
      axios
        .put(`${TICKET_ASSIGN_URL}${ticketType}/${ticket.id}/status/`, {
          status: "close",
          statusCodes
        })
        .then(res => {
          ticket.status = TICKET_STATUS.CLOSED;
          tickets.results[index] = ticket;
          if (isEdit) {
            axios
              .get(`${TICKET_ASSIGN_URL}${ticketType}/${ticket.id}/`)
              .then(res => {
                dispatch(selectTicket(res.data));
              });
          }
          let message = `Ticket #${ticket.short_title} was closed successfully!`;
          const newTicket = res.data.newDeliveries || res.data.newPickups;
          if (newTicket) {
            message = (
              <>
                {message}
                <br />
                {`A new ticket with remaining asset(s) has been created: ${ticket.contract_n}-${newTicket[0]}`}
              </>
            );
          }
          Alert.success({
            message
          });
          if (i === selectedTickets.length - 1) {
            dispatch({
              type: types.POST_TICKET_DATA_REQUEST,
              value: {
                isLoading: false
              }
            });
          }
          return { ...ticket, postRes: "success" };
        })
        .catch(err => {
          if (i === selectedTickets.length - 1) {
            dispatch({
              type: types.POST_TICKET_DATA_REQUEST,
              value: {
                isLoading: false
              }
            });
          }
          if (!showError)
            return { ...ticket, postRes: "error", err: err.response };
          if (err.response.status === 400) {
            Alert.error({
              message: `Ticket #${ticket.short_title}: ${err.response.data.tickets[0].error}`,
              timeout: ALERT_ERROR_TIMEOUT
            });
          } else {
            Alert.error({
              message: `Ticket #${ticket.short_title} can not be closed!`,
              timeout: ALERT_ERROR_TIMEOUT
            });
          }
          return { ...ticket, postRes: "error" };
        })
    );
  });
  return axios.all(updateReqs);
};

export const cancelTicket = (ticket, ticket_type) => (dispatch, getState) => {
  dispatch({
    type: types.POST_TICKET_DATA_REQUEST,
    value: {
      isLoading: true
    }
  });

  return axios
    .put(`${TICKET_ASSIGN_URL}${ticket_type}/${ticket.id}/status/`, {
      status: "cancel"
    })
    .then(res => {
      ticket.status = TICKET_STATUS.CANCELED;
      dispatch(selectTicket(ticket));
      Alert.success({
        message: i18n.t("ticket_was_canceled_successfully", {short_title: ticket.short_title})
      });
      dispatch({
        type: types.POST_TICKET_DATA_REQUEST,
        value: {
          isLoading: false
        }
      });
      return { ...ticket, postRes: "success" };
    })
    .catch(err => {
      if (err.response.status === 400) {
        if (err.response.data.error == "Contract locked by another user") {
          Alert.error({
            message: `Ticket #${ticket.short_title}: The contract is opened on the SRM, so we cannot change this.`,
            timeout: ALERT_ERROR_TIMEOUT
          });
        } else {
          Alert.error({
            message: `Ticket #${ticket.short_title}: ${err.response.data.tickets[0].error}`,
            timeout: ALERT_ERROR_TIMEOUT
          });
        }
      } else {
        Alert.error({
          message: i18n.t("ticket_cannot_be_canceled", {short_title: ticket.short_title}),
          timeout: ALERT_ERROR_TIMEOUT
        });
      }
      dispatch({
        type: types.POST_TICKET_DATA_REQUEST,
        value: {
          isLoading: false
        }
      });
      return { ...ticket, postRes: "error" };
    });
};
